import { useEffect, useState } from "react";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { Dropdown, Menu, Select, Switch, InputNumber } from "antd";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import "../../assets/styles/local/Stock.css";
import settingsIcon from "../../assets/icons/settingsIcon.svg";
import Calender from "../../assets/icons/Calendar with interaction.svg";
import eyeIcon from "../../assets/icons/eye.svg";
import Header from "../../layouts/Header";
import useScreenSize from "../../utils/hooks/useScreenSizeHook";
import plusIcon from "../../assets/icons/Pluswhite.svg";
import AppDatePicker from "../../components/Common/AppDatePicker";
import { CloseCircleOutlined } from "@ant-design/icons";
import moment from "moment";
import { FetchNotEnrolledPayroll } from "../../redux/actions/action";
import "../../assets/styles/local/payroll.css";
import { TimePicker } from "antd";
import arrow from "../../assets/icons/down arrow.svg";
import { API_URL } from "../../redux/constants/type";
import { axiosInstance as axios } from "../../redux/constants/axiosInstance";
import simpleRequest from "../../utils/helpers/simpleRequest";
import { europeanFormatWithSymbol } from "../../utils/European-Format/NumberFormatter";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const statusList = {
  NOT_SUBMITTED: "08dab011-a6cf-4069-887e-83e5f3473116",
  PENDING: "08dab011-a6cf-4069-887e-83e5f3473117",
  CLOSED: "08dab011-a6cf-4069-887e-83e5f3473118",
};

const Payroll = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [calendarIsOpen, setCalendarIsOpen] = useState(false);
  const [date, setDate] = useState(new Date());
  const [loading, setLoading] = useState(true);
  const [isInitialRender, setIsInitialRender] = useState(true);
  const [historyData, setHistoryData] = useState([]);
  const [addNewButtonOpen, setAddNewButtonOpen] = useState(false);
  const [users, setUsers] = useState([]);
  const [period, setPeriod] = useState("weekly");
  const [weekStartingDay, setWeekStartingDay] = useState("Sunday");
  const [monthStartingDay, setMonthStartingDay] = useState("1");
  const [paydayAfterEndPeriod, setPaydayAfterEndPeriod] = useState("0");
  const [statusAfterPayday, setStatusAfterPayday] = useState({
    label: "Closed",
    value: "08dab011-a6cf-4069-887e-83e5f3473118",
  });
  const [applicableTo, setApplicableTo] = useState({
    label: "All",
    value: "00000000-0000-0000-0000-000000000000",
  });
  const [editable, setEditable] = useState(true);
  const [deadlineHourToEdit, setDeadlineHourToEdit] = useState(
    moment("23:59", "HH:mm"),
  );
  const [applicableOption, setApplicableOption] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);

  const companyId = window.localStorage.getItem("companyid");
  const [startDate, setStartDate] = useState(
    moment().startOf("isoWeek").format("YYYY-MM-DDTHH:mm:ss"),
  );
  const [endDate, setEndDate] = useState(
    moment().endOf("isoWeek").format("YYYY-MM-DDTHH:mm:ss"),
  );

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Payroll").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const [paginationObj, setPaginationObj] = useState({
    totalRecords: 0,
    currentPage: 0,
    startRecordIndex: 0,
    endRecordIndex: 0,
    totalPages: 0,
    records: [],
  });

  const dateObj = new Date(deadlineHourToEdit);
  const formattedTime = `${dateObj
    .getUTCHours()
    .toString()
    .padStart(2, "0")}:${dateObj.getUTCMinutes().toString().padStart(2, "0")}`;

  let currentDate1 = moment(); // Current date for reference
  let payrollPeriod = "";
  let payday = null;
  let paydayFormatted = "";

  if (period === "weekly") {
    // Weekly payroll period
    const startOfWeek = currentDate1.clone().startOf("isoWeek"); // Start of the week (Monday)
    const endOfWeek = startOfWeek.clone().add(6, "days"); // End of the week (Sunday)
    payrollPeriod = `${startOfWeek.format(
      "YYYY-MM-DDT00:00:00.000Z",
    )} - ${endOfWeek.format("YYYY-MM-DDT23:59:59.999Z")}`;

    // Add `paydayAfterEndPeriod` to the end of the week
    payday = endOfWeek
      .clone()
      .add(paydayAfterEndPeriod, "days")
      .format("YYYY-MM-DDT23:59:59.999Z");
  } else if (period === "monthly") {
    // Monthly payroll period
    const startOfMonth = currentDate1.clone().startOf("month"); // Start of the month
    const endOfMonth = currentDate1.clone().endOf("month"); // End of the month
    payrollPeriod = `${startOfMonth.format(
      "YYYY-MM-DDT00:00:00.000Z",
    )} - ${endOfMonth.format("YYYY-MM-DDT23:59:59.999Z")}`;

    // Add `paydayAfterEndPeriod` to the end of the month
    payday = endOfMonth
      .clone()
      .add(paydayAfterEndPeriod, "days")
      .format("YYYY-MM-DDT23:59:59.999Z");
  }
  paydayFormatted = moment(payday).format("dddd, DD MMM");

  const createPayroll = async () => {
    const payload = {
      companyId: companyId,
      periodType: period,
      weekStartDay: weekStartingDay,
      monthStartDay: monthStartingDay,
      paydayAfterEndPeriod: paydayAfterEndPeriod,
      statusAfterpayDayId: statusAfterPayday?.value ?? statusAfterPayday,
      applicabletoId: applicableTo?.value ?? applicableTo,
      editable: editable ? 1 : 0,
      deadlineHourtoEdit: formattedTime ?? "",
      payrollPeriod: payrollPeriod,
      payday: payday,
    };
    const resp = await simpleRequest(
      `/api/Payroll/CreatePayrollSetting`,
      "post",
      payload,
    );
    // if (resp?.status === true) setAddNewButtonOpen(false);
  };

  const fetchApplicableDropdown = async () => {
    const resp = await simpleRequest(
      `/api/Payroll/FetchApplicableDropdown`,
      "post",
      {},
    );
    if (resp.data) {
      const options = [
        { label: "All", value: "00000000-0000-0000-0000-000000000000" },
        ...resp.data.map((item) => ({
          label: item.employeeTypeName,
          value: item.employeeTypeId,
        })),
      ];
      setApplicableOption(options);
    } else console.error("API call error:");
  };

  // const statusAfterPaydayOption = [
  //   { label: "Closed", value: "08dab011-a6cf-4069-887e-83e5f3473118" },
  //   { label: "Pending", value: "08dab011-a6cf-4069-887e-83e5f3473117" },
  // ];
  const statusAfterPaydayOption = [
    {
      label: t("Closed"),
      value: "08dab011-a6cf-4069-887e-83e5f3473118",
    },
    {
      label: t("Pending"),
      value: "08dab011-a6cf-4069-887e-83e5f3473117",
    },
  ];

  const handleStatusChange = (value) => {
    setStatusAfterPayday(value);
  };

  const handleApplicableChange = (value) => {
    setApplicableTo(value);
  };

  const fetchNotEnrolledPayroll = useSelector(
    (state) => state.payroll.fetchNotEnrolledPayroll,
  );

  const screenSize = useScreenSize();

  const calculatePagination = (totalCount, pageNumber) => {
    let tempPaginationObj = {
      totalRecords: totalCount,
      currentPage: pageNumber,
      startRecordIndex: Math.max(5 * pageNumber - 4, 1),
      endRecordIndex: Math.min(5 * pageNumber, totalCount),
      totalPages: Math.ceil(totalCount / 5),
      // records: records?.slice((pageNumber - 1) * 5, pageNumber * 5),
    };
    setPaginationObj({ ...paginationObj, ...tempPaginationObj });
  };

  const getWeekRange = (newWeekStart) => {
    const startDateString = moment(newWeekStart).startOf("day").toISOString();
    const endDateString = moment(newWeekStart)
      .add(1, "month")
      .endOf("day")
      .toISOString();
    setStartDate(startDateString);
    setEndDate(endDateString);
  };

  const changeWeek = (type) => {
    const start =
      type === 0
        ? moment(startDate).subtract(1, "month").toISOString()
        : moment(startDate).add(1, "month").toISOString();
    const end =
      type === 0
        ? moment(endDate).subtract(1, "month").endOf("day").toISOString()
        : moment(endDate).add(1, "month").endOf("day").toISOString();
    setStartDate(start);
    setEndDate(end);
    setPageNumber(1);
  };

  const fetchHistoryData = async () => {
    const payload = {
      payrollPeriodStart: moment(startDate).toISOString(),
      payrollPeriodEnd: moment(endDate).toISOString(),
      pagenumber: pageNumber,
      recordsPerPage: 5,
    };
    const resp = await simpleRequest(
      "/api/Payroll/FetchPayrollHistory",
      "post",
      payload,
    );
    if (resp?.status === true) {
      setHistoryData(resp);
      calculatePagination(resp?.totalCount, pageNumber);
    }
  };

  const datePickerFunc = (val) => {
    if (val != undefined) {
      setDate(val);
      getWeekRange(val);
      setCalendarIsOpen(!calendarIsOpen);
      setPageNumber(1);
    }
  };

  const calculateStatusText = (statusId) => {
    switch (statusId) {
      case statusList.NOT_SUBMITTED:
        return { fontWeight: 700, color: "#00246A", cursor: "pointer" };
      case statusList.PENDING:
        return { fontWeight: 500, color: "#00246A" };
      case statusList.CLOSED:
        return { fontWeight: 500, color: "#293427" };
      default:
        return {};
    }
  };

  //Deadline to Edit
  const currentDate = moment();
  let deadlineDate;
  if (period === "monthly") {
    deadlineDate = currentDate.clone().endOf("month").add(1, "days");
  } else if (period === "weekly") {
    deadlineDate = currentDate.clone().endOf("week").add(1, "days");
  } else {
    deadlineDate = currentDate.clone(); // Default to current day for other periods
  }
  const formattedDate = deadlineDate.format("D MMM"); // Format as "6 Oct"

  let payPeriodText = "";

  if (period === "weekly") {
    // Calculate the week starting day
    const startOfWeek = currentDate.clone().day(weekStartingDay); // Use the week starting day dynamically
    const endOfWeek = startOfWeek.clone().add(7, "days"); // 7-day week
    payPeriodText = `${startOfWeek.format("D MMM")} - ${endOfWeek.format(
      "D MMM",
    )}`;
  } else if (period === "monthly") {
    // Calculate the month starting day
    const startOfMonth = currentDate.clone().date(monthStartingDay); // Set month start day dynamically
    const endOfMonth = currentDate.clone().endOf("month");
    payPeriodText = `${startOfMonth.format("D MMM")} - ${endOfMonth.format(
      "D MMM",
    )}`;
  }

  useEffect(() => {
    if (fetchNotEnrolledPayroll != null) {
      if (fetchNotEnrolledPayroll?.status && fetchNotEnrolledPayroll?.data) {
        setUsers(fetchNotEnrolledPayroll?.data);
      }
    }
  }, [fetchNotEnrolledPayroll]);

  useEffect(() => {
    fetchApplicableDropdown();
  }, []);

  useEffect(() => {
    if (!isInitialRender && addNewButtonOpen) {
      const debounceTimeout = setTimeout(() => {
        createPayroll();
      }, 300); // Delay to debounce rapid changes
      return () => clearTimeout(debounceTimeout); // Cleanup timeout
    } else {
      setIsInitialRender(false);
    }
  }, [
    period,
    weekStartingDay,
    monthStartingDay,
    paydayAfterEndPeriod,
    statusAfterPayday,
    applicableTo,
    editable,
    deadlineHourToEdit,
  ]);

  useEffect(() => {
    dispatch(FetchNotEnrolledPayroll(companyId));
  }, [dispatch, companyId]);

  useEffect(() => {
    fetchHistoryData();
  }, [endDate, pageNumber]);

  useEffect(() => {
    getWeekRange(startDate);
  }, [period]);

  const menu = (
    <Menu style={{ padding: "1rem" }}>
      <div className="edit-payroll settings mb-3">
        {/* Settings */}
        {t("Settings")}
        <CloseCircleOutlined onClick={() => setAddNewButtonOpen(false)} />
      </div>
      <Menu.Item key="1">
        <div className="settings">
          <label>
            {/* Period */}
            {t("Period")}
          </label>
          <Select value={period} onChange={setPeriod} style={{ width: "7rem" }}>
            <Select.Option value="weekly">
              {/* Weekly */}
              {t("Weekly")}
            </Select.Option>
            <Select.Option value="monthly">{t("Monthly")}</Select.Option>
          </Select>
        </div>
      </Menu.Item>

      {/* Week Starting Day */}
      <Menu.Item key="2">
        <div className="settings">
          <label>
            {/* Week Starting day */}
            {t("Week Starting day")}
          </label>
          <Select
            value={weekStartingDay}
            onChange={setWeekStartingDay}
            style={{ width: "7rem" }}
          >
            <Select.Option value="Sunday">
              {/* Sunday */}
              {t("Sunday")}
            </Select.Option>
            <Select.Option value="Monday">
              {/* Monday */}
              {t("Monday")}
            </Select.Option>
            <Select.Option value="Tuesday">
              {/* Tuesday */}
              {t("Tuesday")}
            </Select.Option>
            <Select.Option value="Wednesday">
              {/* Wednesday */}
              {t("Wednesday")}
            </Select.Option>
            <Select.Option value="Thursday">
              {/* Thursday */}
              {t("Thursday")}
            </Select.Option>
            <Select.Option value="Friday">
              {/* Friday */}
              {t("Friday")}
            </Select.Option>
            <Select.Option value="Saturday">
              {/* Saturday */}
              {t("Saturday")}
            </Select.Option>
          </Select>
        </div>
      </Menu.Item>
      {/* Month Starting Day */}
      <Menu.Item key="3">
        <div className="settings">
          <label>
            {/* Month Starting Day */}
            {t("Month Starting Day")}
          </label>
          <Select
            value={monthStartingDay}
            onChange={(value) => setMonthStartingDay(value)}
            style={{ width: "7rem" }}
          >
            {[...Array(31).keys()].map((day) => (
              <Select.Option key={day + 1} value={day + 1}>
                {day + 1}
              </Select.Option>
            ))}
          </Select>
        </div>
      </Menu.Item>

      {/* Payday After End Period */}
      <Menu.Item key="4">
        <div className="settings">
          <label>
            {/* Payday After End Period */}
            {t("Payday After End Period")}
          </label>
          <InputNumber
            min={0}
            max={7}
            value={paydayAfterEndPeriod}
            onChange={(value) => setPaydayAfterEndPeriod(value)}
            // addonAfter="days"
            addonAfter={t("days")}
            style={{ width: "7rem" }}
          />
        </div>
      </Menu.Item>

      {/* Status After Payday */}
      <Menu.Item key="5">
        <div className="settings">
          <label>
            {/* Status After Payday */}
            {t("Status After Payday")}
          </label>
          <Select
            value={statusAfterPayday}
            onChange={handleStatusChange}
            style={{ width: "7rem" }}
            defaultActiveFirstOption={true}
            options={statusAfterPaydayOption ?? []}
          ></Select>
          {/* 08dab011-a6cf-4069-887e-83e5f3473116 not submited */}
        </div>
      </Menu.Item>

      {/* Applicable To */}
      <Menu.Item key="6">
        <div className="settings">
          <label>
            {/* Applicable To */}
            {t("Applicable To")}
          </label>
          <Select
            value={applicableTo}
            onChange={handleApplicableChange}
            style={{ width: "7rem" }}
            options={applicableOption ?? []}
          >
            <Select.Option value="All">
              {/* All */}
              {t("All")}
            </Select.Option>
          </Select>
        </div>
      </Menu.Item>

      {/* Editable */}
      <Menu.Item key="7">
        <div className="settings">
          <label>
            {/* Editable */}
            {t("Editable")}
          </label>
          <Switch
            checked={editable}
            onChange={(checked) => setEditable(checked)}
            style={{ marginLeft: 10 }}
          />
        </div>
      </Menu.Item>

      {/* Deadline Hour to Edit */}
      <Menu.Item key="8">
        <div className="settings">
          <label>
            {/* Deadline Hour to Edit */}
            {t("Deadline Hour to Edit")}
          </label>
          <TimePicker
            value={deadlineHourToEdit}
            onChange={(time) => setDeadlineHourToEdit(time)}
            format="HH:mm"
            style={{ width: "7rem" }}
            removeIcon={true}
          />
        </div>
      </Menu.Item>
    </Menu>
  );

  useEffect(() => {
    const fetchPayrollSetting = async () => {
      try {
        const response = await axios({
          method: "post",
          url: `${API_URL}/api/Payroll/FetchPayrollSetting`,
          headers: {
            "Content-Type": "application/json",
          },
          data: {},
        });
        if (response.data.data) {
          setPeriod(response.data.data.periodType);
          setWeekStartingDay(response.data.data.weekStartDay);
          setMonthStartingDay(response.data.data.monthStartDay);
          setPaydayAfterEndPeriod(response.data.data.paydayAfterEndPeriod);
          const matchedOptionApplicable = applicableOption?.find(
            (option) => option.value === response.data.data.applicabletoId,
          );
          setApplicableTo(matchedOptionApplicable || applicableOption[0]);
          setEditable(response.data.data.editable === 1);
          const matchedOption = statusAfterPaydayOption.find(
            (option) => option.value === response.data.data.statusAfterpayDayId,
          );
          setStatusAfterPayday(matchedOption || statusAfterPaydayOption[0]);

          setDeadlineHourToEdit(
            moment(response.data.data.deadlineHourtoEdit, "HH:mm"),
          );
        }
      } catch (error) {
        console.error("API call error:", error);
      }
    };

    if (applicableOption.length) fetchPayrollSetting();
  }, [applicableOption]);

  return (
    <>
      <Header
        leftComponent={
          <div className="fw-bold Contact-heading d-flex gap-3 align-items-center">
            {/* Payroll */}
            {t("Payroll")}
          </div>
        }
      />
      <div className="container-fluid mainWrapper ">
        <div className=" stock row col-12 d-flex  container-tablet">
          <div className="d-flex flex-column stock-wrapper ">
            <div style={{ display: "flex", justifyContent: "end" }}>
              <button
                className="addPayrollBtn"
                onClick={() =>
                  history.push("/off-cycle-payroll", {
                    state: { period, weekStartingDay, monthStartingDay },
                  })
                }
              >
                <img
                  alt=""
                  src={plusIcon}
                  style={{
                    width: "clamp(16px, 1.171vw, 1.171vw)",
                    height: "clamp(16px, 1.171vw, 1.171vw)",
                  }}
                />
                {/* Off Cycle Payroll */}
                {t("Off Cycle Payroll")}
              </button>
            </div>
          </div>
          <div className="col-12 col-md-12 col-lg-12 col-xl-9 col-sm-12 stockCards">
            <div className="payroll-container">
              <div>
                {/* Pay period: */}
                {t("Pay period")}:
                <span className="pay-period">{payPeriodText}</span>
              </div>
              <Dropdown
                overlay={menu}
                open={addNewButtonOpen}
                placement="bottomLeft"
                trigger={["click"]}
              >
                <div
                  className="payroll-settings cursor-pointer"
                  onClick={() => setAddNewButtonOpen(true)}
                >
                  {/* Payroll Settings */}
                  {t("Payroll Settings")}
                  <img
                    src={settingsIcon}
                    alt="Settings Icon"
                    className="settings-icon"
                  />
                </div>
              </Dropdown>
            </div>
            <header className="payroll-header">
              <div className="d-flex gap-1">
                <p>
                  {/* Deadline to Edit */}
                  {t("Deadline to Edit")}
                </p>
                <h3>
                  {formattedTime}, {formattedDate}
                </h3>
              </div>
              <div className="d-flex gap-1">
                <p>
                  {/* Payday */}
                  {t("Payday")}
                </p>
                <h3>{paydayFormatted ?? ""}</h3>
              </div>
              <div className="d-flex gap-1">
                <p>
                  {/* Pending */}
                  {t("Pending")}
                </p>
                <p
                  className="edit-payroll"
                  onClick={() =>
                    history.push("/edit-payroll", {
                      state: {
                        period,
                        weekStartingDay,
                        monthStartingDay,
                        payrollHistoryId:
                          historyData?.data[0]?.payrollHistoryId,
                      },
                    })
                  }
                >
                  {/* Edit Payroll */}
                  {t("Edit profile")}
                </p>
              </div>
              <div className="d-flex gap-1">
                <p>
                  {/* View Timesheets */}
                  {t("View Timesheets")}
                </p>
                <img
                  alt=""
                  src={eyeIcon}
                  style={{
                    alignSelf: "center",
                    color: "rgb(0, 36, 106)",
                    cursor: "pointer",
                  }}
                  onClick={() => history.push("/view-payroll-time-sheet")}
                />
              </div>
            </header>
            <div className="d-flex flex-column gap-3 mt-5">
              <div className="d-flex justify-content-between align-items-center">
                <div
                  className={`table-title-main-payroll ${
                    screenSize === "xs" || screenSize === "sm"
                      ? "d-flex flex-column gap-1"
                      : ""
                  }`}
                >
                  <p className="mb-0">
                    {/* Payroll History */}
                    {t("Payroll History")}
                  </p>
                  <div
                    className={`worktime-nav-main-div ${
                      screenSize === "xs" || screenSize === "sm" ? "p-0" : ""
                    }`}
                  >
                    <div className="worktime-nav-tab gap-2">
                      <img
                        alt=""
                        src={arrow}
                        style={{
                          transform: "rotate(-90deg)",
                          cursor: "pointer",
                          marginLeft: "0.5rem",
                        }}
                        onClick={() => changeWeek(1)}
                      />
                      <h6 style={{ margin: "0", fontSize: "14px" }}>
                        {moment(startDate).format("DD.MM.YYYY")} -{" "}
                        {moment(endDate).format("DD.MM.YYYY")}
                      </h6>
                      <div>
                        <label
                          id="report_calender_DNone"
                          style={{
                            display: "flex",
                            width: "94%",
                          }}
                        >
                          <img
                            style={{ cursor: "" }}
                            src={Calender}
                            alt=""
                            onClick={() => setCalendarIsOpen(!calendarIsOpen)}
                          />
                          <AppDatePicker
                            // open={calendarIsOpen}
                            selected={date}
                            onChange={(val) => {
                              datePickerFunc(val);
                              setCalendarIsOpen(false);
                            }}
                            onSelect={(d, event) => event.preventDefault()}
                            dateFormat="dd/MM/yyyy"
                            className={"ps-2"}
                          />
                        </label>
                      </div>
                      <img
                        alt=""
                        src={arrow}
                        style={{
                          transform: "rotate(90deg)",
                          cursor: "pointer",
                          marginRight: "0.5rem",
                        }}
                        onClick={() => changeWeek(0)}
                      />
                    </div>
                  </div>
                </div>

                {/* Pagination */}
                <div className="stock-custom-pagination">
                  <div>
                    {`${paginationObj.startRecordIndex} - ${paginationObj.endRecordIndex}  of  ${paginationObj?.totalRecords}`}
                  </div>
                  <div className="pagination-buttons">
                    <div
                      className={`update-stock-pagination-button ${
                        pageNumber === 1 ? "disabled" : ""
                      }`}
                      onClick={() => setPageNumber((num) => num - 1)}
                    >
                      <BsChevronLeft />
                    </div>
                    <div className="pagination-current-page">
                      {paginationObj.currentPage}
                    </div>
                    <div
                      className={`update-stock-pagination-button ${
                        pageNumber === 0 ||
                        Math.ceil(historyData?.totalCount / 5) === pageNumber
                          ? "disabled"
                          : ""
                      }`}
                      onClick={() => setPageNumber((num) => num + 1)}
                    >
                      <BsChevronRight />
                    </div>
                  </div>
                </div>
              </div>
              <div className="tableWrapper ">
                <table className="table mb-0">
                  <thead>
                    <tr className="payroll-history-table">
                      <th>
                        {/* Payroll Run */}
                        {t("Payroll Run")}
                      </th>
                      <th>
                        {/* Employees */}
                        {t("Employees")}
                      </th>
                      <th>
                        {/* Submitted */}
                        {t("Submitted")}
                      </th>
                      <th>
                        {/* Payday */}
                        {t("Payday")}
                      </th>
                      <th>
                        {/* Cost of Payroll */}
                        {t("Cost of Payroll")}
                      </th>
                      <th>
                        {/* Status */}
                        {t("Status")}
                      </th>
                    </tr>
                  </thead>
                  <tbody className="border-0">
                    {historyData?.data?.map((item, index) => {
                      return (
                        <tr className="payroll-history-table" key={index}>
                          <td>
                            {item?.payrollType}{" "}
                            <p
                              className="mb-0"
                              style={{
                                marginLeft: "1rem",
                                display: "inline-block",
                              }}
                            >
                              {" "}
                              {moment(
                                `${item?.payrollPeriodStart}.000Z`,
                              ).format("DD MMM")}{" "}
                              -{" "}
                              {moment(`${item?.payrollPeriodEnd}.000Z`).format(
                                "DD MMM",
                              )}
                            </p>
                          </td>
                          <td>{item?.noofEmployee}</td>
                          <td>
                            {moment
                              .utc(item?.subsubmittedDate)
                              .format("DD.MM.YYYY")}
                          </td>
                          <td>
                            {moment.utc(item?.payday).format("DD.MM.YYYY")}
                          </td>
                          <td>{europeanFormatWithSymbol(item?.totalCost)}</td>
                          <td
                            onClick={() => {
                              if (item?.statusId == statusList.NOT_SUBMITTED) {
                                history.push("/payroll-status", {
                                  state: {
                                    period,
                                    weekStartingDay,
                                    monthStartingDay,
                                    payrollHistoryId:
                                      historyData?.data[0]?.payrollHistoryId,
                                  },
                                });
                              }
                            }}
                            style={calculateStatusText(item?.statusId)}
                          >
                            {item?.status}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                {historyData?.data?.length === 0 && (
                  <div className="nodata-found bg-white">
                    <p>
                      {/* No data found .. */}
                      {t("No data found ..")}
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div
            className={`col-md-4 col-lg-12 col-xl-3  col-sm-12 mb-3 ${
              screenSize === "xs" || screenSize === "sm" || screenSize === "md"
                ? "width-100"
                : "width-19-vw"
            }`}
          >
            <p className="asc_Client_Input_For_Long_Payroll mb-21">
              {/* Not Enrolled in Payroll */}
              {t("Not Enrolled in Payroll")}
            </p>
            <div className="off-cycle-payroll-container">
              <div className="user-list">
                {users.map((user, index) => {
                  const getInitials = (firstName, lastName) => {
                    const firstInitial = firstName
                      ? firstName[0].toUpperCase()
                      : "";
                    const lastInitial = lastName
                      ? lastName[0].toUpperCase()
                      : "";
                    return firstInitial + lastInitial;
                  };

                  const initials = getInitials(user.firstname, user.lastname);

                  return (
                    <div key={index + user.name} className="user-item">
                      {user.imageurl.startsWith("https") ? (
                        <img
                          src={user.imageurl}
                          alt={user.name}
                          className="user-image"
                        />
                      ) : (
                        <div className="user-initials">{initials}</div>
                      )}
                      <p className="user-name">
                        {user.firstname + " " + user.lastname}
                      </p>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Payroll;
